<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="New Counter" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
              outlined autofocus
              :hide-details="nameErrors.length === 0"
              dense
              :error-messages="nameErrors"
              v-model="Counter.name"
              label="Name"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6">
            <v-text-field
              outlined 
              :hide-details="neededErrors.length === 0"
              :error-messages="neededErrors"
              dense
              v-model="Counter.needed"
              label="Needed"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6">
            <v-text-field
              outlined 
              :hide-details="receivedErrors.length === 0"
              :error-messages="receivedErrors"
              dense
              v-model="Counter.received"
              label="Received"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6">
            <v-text-field
              outlined 
              hide-details
              dense
              v-model="Counter.monthly"
              label="Monthly"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6">
            <v-text-field
              outlined 
              hide-details
              dense
              v-model="Counter.yearly"
              label="Yearly"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field
              outlined 
              hide-details
              dense
              v-model="Counter.dep"
              label="Department"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import counterService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-counter",
  props: {
    createDialog: {
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      Counter: {
        name: null,
        needed: 0,
        received: 0,
        dep: null,
        metadata: {
          monthly: 0,
          yearly: 0,
        }
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    Counter: {
      name: { required },
      needed: { required },
      received: { required },
      dep: { required },
      metadata: {
        monthly: { required },
        yearly: { required },
      }
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Counter.name.$dirty) return errors;
      if (!this.$v.Counter.name.required) 
          errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    neededErrors() {
      const errors = [];
      if (!this.$v.Counter.needed.$dirty) return errors;
      if (!this.$v.Counter.needed.required) 
          errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    receivedErrors() {
      const errors = [];
      if (!this.$v.Counter.received.$dirty) return errors;
      if (!this.$v.Counter.received.required) 
          errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Counter = {
        name: null,
        needed: 0,
        received: 0,
        metadata: {
          monthly: null,
          yearly: null,
        }
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return counterService
          .create(this.Counter)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Counter is created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>


<style scoped></style>
